import { render, staticRenderFns } from "./crm-orders.vue?vue&type=template&id=a7a82730&scoped=true&"
import script from "./crm-orders.vue?vue&type=script&lang=js&"
export * from "./crm-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a82730",
  null
  
)

export default component.exports